export enum PaymentTypeDataHooks {
  Payment_Type_Selection = 'payment-type-selection',
  Payment_Type_Selector_Label = 'payment-type-selector-label',
  Dropdown = 'dropdown',
}
